import React from 'react';
import { Instagram, Mail, Phone } from 'lucide-react';
import { personalInfo } from '../mock';

const Footer = () => {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;
      window.scrollTo({ top: offsetPosition, behavior: 'smooth' });
    }
  };

  return (
    <footer className="py-12 px-4" style={{ backgroundColor: '#1e3a5f' }}>
      <div className="container mx-auto">
        <div className="grid md:grid-cols-3 gap-8 mb-8">
          <div>
            <h3 className="text-2xl font-bold mb-4 text-white">Hotny Mota</h3>
            <p className="text-gray-300 mb-4">
              Analista Imobiliário especializado em regularização de imóveis e projetos de engenharia.
            </p>
            <div className="flex space-x-4">
              <a
                href={personalInfo.instagram}
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full flex items-center justify-center transition-colors duration-200"
                style={{ backgroundColor: '#c17835' }}
              >
                <Instagram className="w-5 h-5 text-white" />
              </a>
              <a
                href={`mailto:${personalInfo.email}`}
                className="w-10 h-10 rounded-full flex items-center justify-center transition-colors duration-200"
                style={{ backgroundColor: '#c17835' }}
              >
                <Mail className="w-5 h-5 text-white" />
              </a>
              <a
                href={`tel:${personalInfo.phone}`}
                className="w-10 h-10 rounded-full flex items-center justify-center transition-colors duration-200"
                style={{ backgroundColor: '#c17835' }}
              >
                <Phone className="w-5 h-5 text-white" />
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-lg font-bold mb-4 text-white">Navegação</h4>
            <ul className="space-y-2">
              {['home', 'services', 'projects', 'about', 'contact'].map((section) => (
                <li key={section}>
                  <button
                    onClick={() => scrollToSection(section)}
                    className="text-gray-300 hover:text-[#c17835] transition-colors duration-200"
                  >
                    {section === 'home' && 'Início'}
                    {section === 'services' && 'Serviços'}
                    {section === 'projects' && 'Portfólio'}
                    {section === 'about' && 'Sobre'}
                    {section === 'contact' && 'Contato'}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-bold mb-4 text-white">Serviços</h4>
            <ul className="space-y-2 text-gray-300">
              <li>Regularização de Terrenos</li>
              <li>Averbação de Construção</li>
              <li>Desdobro e Unificação</li>
              <li>Projetos Arquitetônicos</li>
              <li>Projetos Estruturais</li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-600 pt-8">
          <p className="text-center text-gray-300">
            © {new Date().getFullYear()} Hotny Mota - Analista Imobiliário. Todos os direitos reservados.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;